import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import Multiselect from '../EventModal/components/Multiselect'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material'
import { useAppServices } from 'hook/services'
import { useUserInfo } from 'context/user'
import MDInput from 'components/MDInput'
import { useParams } from 'react-router-dom'
import Editor from 'components/editor'

const EditTriggerModel = ({
  editData,
  handleRefresh,
  index,
  appData,
  appCollections,
  appTriggerModel,
}) => {
  const { app_id } = useParams()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const [user] = useUserInfo()

  const handlemodal = () => {
    setOpenAddProduct(true)
  }

  // filter appCollections by app_id
  appCollections = appCollections.filter((data) => data.app_id === appData?.app_id)

  useEffect(() => { }, [])

  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)
    const [editor, setEditor] = useState(editData?.description || '')
    const [hasUIInterface, setHasUIInterface] = useState(editData?.hasUIInterface || false)

    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true)

      try {
        // Safely parse selected triggers
        const selectedTriggerModels = JSON.parse(e.target.app_trigger_keys?.value || '[]')

        const triggerData = {
          name: e.target.name.value,
          description: editor,
          app_collection_id: e.target.app_collection_id.value,
          link: e.target.link.value,
          trigger_key: e.target.trigger_key.value,
          loom_video: e.target.loom_video.value,
          hasUIInterface,
          app_trigger_keys: selectedTriggerModels?.map((item) => item.value) || [],
          sample_response: e?.target?.sample_response?.value,

        }

        const triggers = [...(appData?.triggers || [])]
        triggers[index] = triggerData
        const payload = {
          _id: appData?._id,
          app_collection_id: e.target.app_collection_id.value,
          triggers: triggers,
        }

        const { response } = await AppService.app.update({
          payload: payload,
        })

        if (response) {
          const collection = appCollections.find(
            (data) => data._id === e.target.app_collection_id.value
          )
          const payload_collection = {
            app_id: appData.app_id,
            id: e.target.app_collection_id.value,
            triggers: [
              ...(collection?.triggers?.filter((data, i) => i !== index) || []),
              triggerData,
            ],
          }

          const res = await AppService.AppCollections.update({
            payload: payload_collection,
          })

          if (res) {
            setProcessing(false)
            onClose()
            handleRefresh()
          }
        }
      } catch (error) {
        console.error('Error updating trigger:', error)
        setProcessing(false)
      }
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 700,
      height: '80vh',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
      overflowY: 'auto',
    }

    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              App Trigger
            </MDTypography>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" name="name" fullWidth defaultValue={editData?.name} />
            </MDBox>

            <MDBox
            >
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Description
              </MDTypography>
              <Editor
                handleChange={(data) => {
                  setEditor(data)
                }}
                data={editor}
              />
            </MDBox>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Youtube Link
              </MDTypography>
              <MDInput label="Youtube Link" name="link" defaultValue={editData?.link} fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Trigger Key
              </MDTypography>
              <MDInput label="Trigger Key" name="trigger_key" defaultValue={editData?.trigger_key} fullWidth />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                loom video
              </MDTypography>
              <MDInput label="loom video" name="loom_video" defaultValue={editData?.loom_video} fullWidth />
            </MDBox>
            {/* <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Select Actions Category
              </MDTypography>
              <Select
                label="Actions Category"
                name="app_collection_id"
                fullWidth
                defaultValue={editData?.app_collection_id}
              >
                {appCollections?.map((data) => (
                  <MenuItem key={data?._id} value={data?._id}>
                    {data?.name}
                  </MenuItem>
                ))}
              </Select>
            </MDBox> */}

            <MDBox>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={hasUIInterface}
                      onChange={(e) => setHasUIInterface(e.target.checked)}
                      name="hasUIInterface"
                    />
                  }
                  label="Is trigger have UI interface"
                />
              </FormGroup>
            </MDBox>

            {hasUIInterface && (
              <MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    Select Trigger Key
                  </MDTypography>
                  <Multiselect
                    name="app_trigger_keys"
                    isMulti={true}
                    data={appTriggerModel?.map((data) => ({
                      value: {
                        id: data?._id,
                        name: data?.name,
                        key: data?.key,
                        sample_response: data?.sample_response
                      },
                      label: data?.name,
                    }))}
                    edit_data={editData?.app_trigger_keys?.map((item) => ({
                      value: {
                        id: item?._id,
                        name: item?.name,
                        key: item?.key,
                        sample_response: item?.sample_response
                      },
                      label: item?.name,
                    }))}
                  />
                </MDBox>
                <MDBox>
                  <MDTypography
                    variant="button"
                    sx={{ fontSize: '14px', fontWeight: '500' }}
                    mb={1}
                  >
                    Sample Response
                  </MDTypography>
                  <MDBox
                    sx={{
                      maxHeight: '150px',
                      overflowY: 'auto',

                      borderRadius: '4px',

                    }}>
                    <TextareaAutosize
                      type="text"
                      name="sample_response"
                      defaultValue={editData?.sample_response}
                      minRows={3}
                      style={{ width: '100%' }}
                    />
                  </MDBox>
                </MDBox>
              </MDBox>
            )}

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={onClose}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Update
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }

  return (
    <>
      <MDButton
        variant="contained"
        color="info"
        size="small"
        sx={{ marginLeft: 2 }}
        onClick={handlemodal}
      >
        Edit
      </MDButton>
      <AddProduct open={openAddProduct} onClose={() => setOpenAddProduct(false)} />
    </>
  )
}

export default EditTriggerModel
